import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { appLanguageSelector } from '../../redux/app/selectors'
import {
  createGridValueFormatter,
  getLocaleFromLanguage,
  NumberFormatOptions
} from '../components/custom/Grid/gridFormatUtils'

export const useGridFormatters = () => {
  const language = useSelector(appLanguageSelector)
  const locale = useMemo(() => getLocaleFromLanguage(language), [language])

  return useMemo(
    () => ({
      locale,
      percentage: (decimals = 2) =>
        createGridValueFormatter(locale, {
          style: 'percent',
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }),
      decimal: (decimals = 2) =>
        createGridValueFormatter(locale, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }),
      integer: () =>
        createGridValueFormatter(locale, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }),
      custom: (options: NumberFormatOptions) => createGridValueFormatter(locale, options)
    }),
    [locale]
  )
}
